import type { ServiceCalibrationKind } from '../../types';

import useTranslate from 'app/i18n/useTranslate';

const useTranslation = (): {
    ALL_UNITS: string;
    CALIBRATION_KINDS: Record<ServiceCalibrationKind, string>;
    LOG_SERVICE: string;
    SERVICE_HISTORY: string;
    UPCOMING: string;
} => {
    const t = useTranslate('droneServiceLogTab');

    return {
        ALL_UNITS: t('allUnits'),
        CALIBRATION_KINDS: {
            FLOW: t('calibrationFlow'),
            LEVEL: t('calibrationLevel'),
            MAGNETOMETER: t('calibrationMagnetometer'),
            PUMP: t('calibrationPump'),
            WEIGHT: t('calibrationWeight')
        },
        LOG_SERVICE: t('logService'),
        SERVICE_HISTORY: t('serviceHistory'),
        UPCOMING: t('upcoming')
    };
};

export default useTranslation;
